// 모바일 카드는 PC 카드와 동일한 디자인/구조 사용
import EstateCard from "./Sale";
export default EstateCard;
